export const LINE_CHUNK_SIZE = 64 * 1024;

/** Yield after this many bytes read during ranged streaming. */
export const READ_RANGE_YIELD_EVERY_BYTES = 256 * 1024;

export interface ReadFileResult {
  content: string;
  totalLines?: number;
  size: number;
  /** When set, the first line in the range is partial; next chunk starts at this character offset within that line. */
  lineOffset?: number;
  mimeType?: string;
  /** Absolute resolved path on disk (full reads). */
  resolvedPath?: string;
}
